import CustomPagination from '@/platform/common/components/CustomPagination/CustomPagination';
import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import SearchBarFilter from '@/platform/common/components/SearchBarFilter/SearchBarFilter';
import { useFilters } from '@/platform/hooks/useFilters';
import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import {
    Button,
    Container,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    MenuSeparator,
    Segment,
    SegmentContent,
    SegmentFooter,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import {
    EllipsisVerticalIcon,
    PencilIcon,
    PlusIcon,
    TrashIcon,
} from '@heroicons/react/24/outline';
import { Link, router, usePage } from '@inertiajs/react';

const IndexView = () => {
    const { auth, resellers } = usePage().props;
    const { updateFilters, isSorted } = useFilters(['resellers']);
    const confirm = useConfirmationStore(state => state.confirm);

    const destroy = reseller => {
        router.delete(`/resellers/${reseller.id}`);
    };

    const confirmDelete = reseller => {
        confirm({
            description:
                'Weet u zeker dat u deze reseller wilt verwijderen? Gekoppelde informatie zal ook niet meer beschikbaar zijn.',
            onConfirm: close => {
                destroy(reseller);
                close();
            },
        });
    };

    return (
        <Container>
            <Segment>
                <SegmentHeader
                    header={`Resellers (${resellers?.meta?.total || 0})`}
                >
                    {auth.permissions.includes('create resellers') && (
                        <Button
                            variant='primary'
                            as={Link}
                            href='/resellers/create'
                        >
                            <PlusIcon className='size-5' />
                            Nieuwe reseller
                        </Button>
                    )}
                </SegmentHeader>
                <SegmentContent>
                    <SearchBarFilter only={['resellers']} />

                    <Table striped>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell
                                    sorted={isSorted('name')}
                                    onClick={() =>
                                        updateFilters('sort', 'name')
                                    }
                                >
                                    Naam
                                </TableHeaderCell>
                                <TableHeaderCell />
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {resellers?.meta?.total === 0 && (
                                <NoDataRow numberOfColumns={2} />
                            )}

                            {resellers?.data?.map(reseller => (
                                <TableRow key={reseller.id}>
                                    <TableCell>
                                        {auth?.permissions?.includes(
                                            'update resellers'
                                        ) ? (
                                            <Link
                                                href={`/resellers/${reseller.id}/edit`}
                                            >
                                                {reseller.name}
                                            </Link>
                                        ) : (
                                            reseller.name
                                        )}
                                    </TableCell>
                                    <TableCell
                                        className='w-px'
                                        singleLine
                                        textAlign='right'
                                    >
                                        {[
                                            'update resellers',
                                            'delete resellers',
                                        ]?.some(permission =>
                                            auth?.permissions?.includes(
                                                permission
                                            )
                                        ) && (
                                            <Menu>
                                                <MenuButton>
                                                    <EllipsisVerticalIcon className='size-5' />
                                                </MenuButton>
                                                <MenuItems anchor='bottom end'>
                                                    {auth?.permissions?.includes(
                                                        'update resellers'
                                                    ) && (
                                                        <>
                                                            <MenuItem
                                                                as={Link}
                                                                href={`/resellers/${reseller.id}/edit`}
                                                                icon={
                                                                    PencilIcon
                                                                }
                                                            >
                                                                Wijzigen
                                                            </MenuItem>

                                                            <MenuSeparator />
                                                        </>
                                                    )}
                                                    {auth?.permissions?.includes(
                                                        'delete resellers'
                                                    ) && (
                                                        <MenuItem
                                                            className='text-red-600'
                                                            onClick={() =>
                                                                confirmDelete(
                                                                    reseller
                                                                )
                                                            }
                                                            icon={TrashIcon}
                                                        >
                                                            Verwijderen
                                                        </MenuItem>
                                                    )}
                                                </MenuItems>
                                            </Menu>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>

                <SegmentFooter>
                    <CustomPagination
                        meta={resellers?.meta}
                        only={['resellers']}
                    />
                </SegmentFooter>
            </Segment>
        </Container>
    );
};

export default IndexView;
